import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/global/atoms'
import I18n from 'translations/i18n'

function CheckAll(props) {
  const { isCheckAll, checkedAll, unCheckedAll, disableSelectAll } = props

  function onChange(checked) {
    if (checked) {
      return checkedAll()
    }
    return unCheckedAll()
  }

  return (
    <div className="jisr-eligible-people__checked-all">
      <Input.Checkbox
        label={I18n.t('all_emplyees')}
        onChange={onChange}
        checked={isCheckAll}
        disabled={disableSelectAll}
        testId="check-all"
      />
    </div>
  )
}

CheckAll.propTypes = {
  isCheckAll: PropTypes.bool,
  checkedAll: PropTypes.func,
  unCheckedAll: PropTypes.func,
  disableSelectAll: PropTypes.bool,
}

export default React.memo(CheckAll)
